<template>
    <div class="line-wrap">
        <div ref="chartRef" class="chart-container" :style="{ width: '100%', height: '67vh' }"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    name: 'LineChart',
    props: {
        grid: {
            type: Object,
            default: () => ({
                left: '13%',
                right: '0%',
                bottom: '14%',
                top: '15%'
            })
        },
        legend: {
            type: Object,
            default: () => ({})
        },
        // 接收时间
        time: {
            type: Array,
            default: () => []
        },
        // 接收水
        water: {
            type: Array,
            default: () => []
        },
        // 接收电
        electric: {
            type: Array,
            default: () => []
        },
        // 接收气
        gas: {
            type: Array,
            default: () => []
        },
        yAxis: {
            type: Object,
            default: () => ({})
        },
        unit: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            chartInstance: null,
            fakeXAxisData: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            fakeWater: [0, 0, 0, 0, 0, 0, 0],
            fakeElectric: [0, 0, 0, 0, 0, 0, 0],
            fakeGas: [0, 0, 0, 0, 0, 0, 0]
        }
    },
    computed: {
        parseXAxis() {
            return this.time.length ? this.time : this.fakeXAxisData
        },
        chartOption() {
            const xData = this.parseXAxis
            const waterData = this.water.length ? this.water : this.fakeWater
            const electricData = this.electric.length ? this.electric : this.fakeElectric
            const gasData = this.gas.length ? this.gas : this.fakeGas

            return {
                grid: this.grid,
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}<br/>水：{c0}<br/>电：{c1}<br/>气：{c2}',
                    textStyle: { color: '#fff' },
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    borderWidth: 1
                },
                legend: {
                    data: ['水', '电', '气'],
                    top: 10,
                    textStyle: { color: '#333' },
                    ...this.legend
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLine: { lineStyle: { color: '#eee' } },
                    axisLabel: { color: '#666' }
                },
                yAxis: {
                    type: 'value',
                    splitLine: { lineStyle: { color: '#eee', type: 'dashed' } },
                    axisLabel: { color: '#666' },
                    ...this.yAxis
                },
                series: [
                    {
                        name: '水',
                        type: 'line',
                        smooth: true,
                        data: waterData,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2, color: '#4FC3F7' },
                        itemStyle: { color: '#4FC3F7' }
                    },
                    {
                        name: '电',
                        type: 'line',
                        smooth: true,
                        data: electricData,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2, color: '#FF9800' },
                        itemStyle: { color: '#FF9800' }
                    },
                    {
                        name: '气',
                        type: 'line',
                        smooth: true,
                        data: gasData,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2, color: '#4CAF50' },
                        itemStyle: { color: '#4CAF50' }
                    }
                ],
                backgroundColor: 'transparent'
            }
        }
    },
    mounted() {
        this.initChart()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        this.chartInstance?.dispose()
    },
    watch: {
        time: { deep: true, handler: 'updateChart' },
        water: { deep: true, handler: 'updateChart' },
        electric: { deep: true, handler: 'updateChart' },
        gas: { deep: true, handler: 'updateChart' }
    },
    methods: {
        initChart() {
            if (!this.$refs.chartRef) return
            this.chartInstance = echarts.init(this.$refs.chartRef)
            this.updateChart()
        },
        updateChart() {
            this.chartInstance?.setOption(this.chartOption, true)
        },
        handleResize() {
            this.chartInstance?.resize()
        }
    }
}
</script>

<style scoped lang="scss">
.line-wrap {
    width: 96%;
    height: 100%;
    background: #fafbfc;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chart-container {
    width: 100%;
    height: 100%;
}
</style>